const {
  host,
  pathname,
  protocol
} = window.location

const PATH = 'images/detect.webp'
const URL  = `${ protocol }//${ host }${ pathname }${ PATH }`

const detect = () => new Promise(resolve => {
  const handleLoad = () => {
    document.body.classList.add('webp')
    resolve()
  }

  const handleError = () => {
    document.body.classList.add('no-webp')
    resolve()
  }

  const image = document.createElement('img')
  image.addEventListener('load', handleLoad)
  image.addEventListener('error', handleError)
  image.setAttribute('src', URL)
})

export default detect
